// src/pages/TermsAndConditions.js
import './TermsAndConditions.css';

export default function TermsAndConditions() {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>

      <p>
        Welcome to WePrint PhotoBooks! By accessing our website or purchasing our products,
        you agree to be bound by the following terms and conditions. Please read them carefully.
      </p>

      <h2>1. General</h2>
      <p>
        These terms and conditions govern your use of this website and all services and products
        provided by WePrint PhotoBooks.
      </p>

      <h2>2. Orders and Customization</h2>
      <ul>
        <li>All custom photobook orders are processed only after full payment is received.</li>
        <li>Designs are finalized upon customer approval; no changes will be accepted afterward.</li>
        <li>We are not responsible for errors (spelling, layout) approved in final previews.</li>
      </ul>

      <h2>3. Delivery</h2>
      <p>
        Delivery timelines may vary based on location and seasonal demand. We strive to deliver within 5–10 business days.
      </p>

      <h2>4. Returns and Refunds</h2>
      <p>
        As these are custom products, we do not accept returns. However, if you receive damaged goods,
        contact us within 48 hours for resolution.
      </p>

      <h2>5. Intellectual Property</h2>
      <p>
        All content, logos, and designs are property of WePrint PhotoBooks. Any unauthorized use
        is strictly prohibited.
      </p>

      <h2>6. Contact Us</h2>
      <p>
        If you have questions about our terms and conditions, please contact us at:
      </p>
      <ul>
        <li>Email: <a href="mailto:info@weprintphotobooks.com">info@weprintphotobooks.com</a></li>
        <li>Phone: <a href="tel:+918861494444">+91 88614 94444</a></li>
      </ul>
    </div>
  );
}
